"use client";

import { useEffect, useState } from "react";
import { Maximize2, Minimize2, Minus, X } from "lucide-react";
import { isStudioDesktopShell } from "@/studio/lib/desktopApp";

/** Min / max / close for frameless Electron (Win/Linux). macOS uses traffic lights. */
export function StudioDesktopWindowControls() {
  const [maximized, setMaximized] = useState(false);
  const platform =
    typeof window !== "undefined" ? window.studioDesktop?.platform : undefined;
  const show =
    isStudioDesktopShell() && platform !== "darwin" && platform !== undefined;

  useEffect(() => {
    if (!show) return;
    const bridge = window.studioDesktop;
    if (!bridge?.onWindowMaximizedChanged) return;
    void bridge.isWindowMaximized?.().then(setMaximized);
    return bridge.onWindowMaximizedChanged(setMaximized);
  }, [show]);

  if (!show) return null;

  const bridge = window.studioDesktop;

  return (
    <div className="studio-desktop-window-controls" data-studio-sfx="none">
      <button
        type="button"
        className="studio-settings-pill studio-settings-trigger studio-head-maximize-btn studio-desktop-window-btn"
        onClick={() => bridge?.minimizeWindow()}
        aria-label="Minimize window"
      >
        <Minus className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
      <button
        type="button"
        className="studio-settings-pill studio-settings-trigger studio-head-maximize-btn studio-desktop-window-btn"
        onClick={() => bridge?.toggleMaximizeWindow()}
        aria-label={maximized ? "Restore window" : "Maximize window"}
        aria-pressed={maximized}
      >
        {maximized ? (
          <Minimize2 className="h-3.5 w-3.5" aria-hidden="true" />
        ) : (
          <Maximize2 className="h-3.5 w-3.5" aria-hidden="true" />
        )}
      </button>
      <button
        type="button"
        className="studio-settings-pill studio-settings-trigger studio-head-maximize-btn studio-desktop-window-btn is-close"
        onClick={() => bridge?.closeWindow()}
        aria-label="Close window"
      >
        <X className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
    </div>
  );
}
